import React, {Component} from 'react';
import { FieldGroups } from "../FieldGroups";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {FieldGroup} from "../FieldGroup";
import {addSubField} from "../../../../../store/actions/subFields";
import connect from "react-redux/es/connect/connect";
import {addNewParameterFilled} from "../../../../../store/actions/parameters";
import {isParametersValid} from "../../../ClassicFunctions";
import {endpointFieldChange} from "../../../../../store/actions/endpoints";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

class Pagination extends Component {
  render() {

    const { settings, premium, parameters, addNewParameterFilled, endpointFieldChange } = this.props;

    return (
      <FieldGroupContext.Consumer>

        {({ endpointId, endpoint, currentItem, action }) => (
          <React.Fragment>
            <h3>Pagination</h3>

            <FieldGroup
              label="Page number"
              fields={typeof settings.endpoints[endpointId].displayData[0].pagination !== 'undefined'
                ? settings.endpoints[endpointId].displayData[0].pagination[0].fields
                : []}
              group="pagination"
              groupId={0}
              currentItem={currentItem}
              action={action}
            />
            <Tippy content={<span>This will add a custom parameter called "page" that can be used by you to connect the field source with this custom parameter.</span>}>
              <button
                className="button button-secondary"
                onClick={() => (premium || isParametersValid(parameters.length))
                  && addNewParameterFilled(endpointId, 'page')
                  && endpointFieldChange( true, endpointId, 'parametersSection' )
                }
              >
                Add custom parameter
              </button>
            </Tippy>
          </React.Fragment>
        )}

      </FieldGroupContext.Consumer>
    );
  }
};

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
  addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
  addNewParameterFilled: ( endpointId, name ) => dispatch( addNewParameterFilled( endpointId, name ) ),
  endpointFieldChange: ( value, endpointId, field ) => dispatch( endpointFieldChange( value, endpointId, field ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Pagination);
